import * as React from 'react';
import type { SVGProps } from 'react';
const SvgKing = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} {...props}>
    <path d="M19.356 5.302a1 1 0 0 0-1.104.272l-2.75 3.094a.504.504 0 0 1-.782-.042l-3.906-5.47a1.04 1.04 0 0 0-1.628 0L5.28 8.626a.504.504 0 0 1-.782.042l-2.75-3.094A1 1 0 0 0 0 6.238v10a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-10a1 1 0 0 0-.644-.936" />
  </svg>
);
export default SvgKing;
